// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"802b5f41","453":"89888a5d"}[chunkId] + ".chunk.js";
};